import React from 'react';
import {
  faBuilding,
  faPlug,
  faClock,
  faTriangleExclamation,
  faHeartPulse,
} from '@fortawesome/free-solid-svg-icons';
import * as S from './styles';
import Table from '../../../components/interface/Tabela';
import KpiCards from '../../../components/interface/KpiCards';
import EstadoVazio from '../../../components/interface/EstadoVazio';
import { Empresa } from '../../Cadastros/Empresas/types';
import { avaliaSaude, dataHoraPtBr, resumo } from './saude';

export interface SaudeIntegracaoProps {
  empresas: Empresa[];
  erro: string;
  hoje: string;
}

const SaudeIntegracaoView: React.FC<SaudeIntegracaoProps> = ({
  empresas,
  erro,
  hoje,
}) => {
  const contagem = resumo(empresas, hoje);

  const linhas = empresas.map((empresa) => {
    const saude = avaliaSaude(empresa, hoje);
    // tudo como TEXTO: a coluna alimenta a exportacao para Excel, e objeto
    // sairia como [object Object] na planilha. A cor do badge sai de
    // `estadoChave`, que nao vira coluna.
    return {
      codigo: empresa.codigo,
      empresa: empresa.nome || empresa.identificador,
      identificador: empresa.identificador,
      estado: saude.rotulo,
      estadoChave: saude.estado,
      detalhe: saude.detalhe,
      sincronizacao: dataHoraPtBr(empresa.ultima_sincronizacao),
      url: empresa.url_erp || '—',
    };
  });

  return (
    <S.Container>
      {erro && <S.Alerta role="alert">{erro}</S.Alerta>}

      {empresas.length > 0 && (
        <KpiCards
          itens={[
            { rotulo: 'Empresas', valor: contagem.total, icone: faBuilding },
            { rotulo: 'Integradas', valor: contagem.integradas, icone: faPlug },
            { rotulo: 'Atrasadas', valor: contagem.atrasadas, icone: faClock },
            {
              rotulo: 'Pendentes',
              valor: contagem.pendentes,
              icone: faTriangleExclamation,
            },
          ]}
        />
      )}

      {empresas.length === 0 && !erro ? (
        <EstadoVazio
          icone={faHeartPulse}
          titulo="Nenhuma empresa cadastrada"
          descricao="Cadastre uma empresa em Cadastros > Empresas para acompanhar a integração com o ERP."
        />
      ) : (
        empresas.length > 0 && (
          <Table
            data={linhas}
            columns={[
              { key: 'empresa', header: 'Empresa', filterable: true },
              { key: 'identificador', header: 'Banco', filterable: true },
              {
                key: 'estado',
                header: 'Situação',
                td: (linha: any) => (
                  <S.Badge estado={linha.estadoChave}>{linha.estado}</S.Badge>
                ),
              },
              {
                key: 'detalhe',
                header: 'Detalhe',
                td: (linha: any) => <S.Detalhe>{linha.detalhe}</S.Detalhe>,
              },
              { key: 'sincronizacao', header: 'Última sincronização' },
              {
                key: 'url',
                header: 'URL do ERP',
                td: (linha: any) => <S.Url>{linha.url}</S.Url>,
              },
            ]}
            exportable={true}
          />
        )
      )}
    </S.Container>
  );
};

export default SaudeIntegracaoView;
